import { CRUDFactory } from '../CRUDFactory';

const namespace = 'email-protocols';
export const CRUDEmailProtocol = CRUDFactory(namespace);
